"use strict";
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolicyPremiumInstallmentSchedule = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const policy_entity_1 = require("./policy.entity");
let PolicyPremiumInstallmentSchedule = class PolicyPremiumInstallmentSchedule {
};
exports.PolicyPremiumInstallmentSchedule = PolicyPremiumInstallmentSchedule;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], PolicyPremiumInstallmentSchedule.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "policy_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], PolicyPremiumInstallmentSchedule.prototype, "policyId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "installment_1", type: "date", nullable: false }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], PolicyPremiumInstallmentSchedule.prototype, "installment1", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "installment_2", type: "date", nullable: false }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], PolicyPremiumInstallmentSchedule.prototype, "installment2", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: "created_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], PolicyPremiumInstallmentSchedule.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({ name: "updated_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_d = typeof Date !== "undefined" && Date) === "function" ? _d : Object)
], PolicyPremiumInstallmentSchedule.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => policy_entity_1.Policy, (policy) => policy.premiumInstallments, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "policy_id" }),
    tslib_1.__metadata("design:type", typeof (_e = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _e : Object)
], PolicyPremiumInstallmentSchedule.prototype, "policy", void 0);
exports.PolicyPremiumInstallmentSchedule = PolicyPremiumInstallmentSchedule = tslib_1.__decorate([
    (0, typeorm_1.Entity)("policy_premium_installment_schedules")
], PolicyPremiumInstallmentSchedule);
